/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRating14Plus = createReactComponent("outline", "rating-14-plus", "IconRating14Plus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 15v-6", "key": "svg-1" }], ["path", { "d": "M15.5 12h3", "key": "svg-2" }], ["path", { "d": "M17 10.5v3", "key": "svg-3" }], ["path", { "d": "M12.5 15v-6m-2.5 0v4h3", "key": "svg-4" }]]);

export { IconRating14Plus as default };
//# sourceMappingURL=IconRating14Plus.mjs.map
